import { theme } from "../../utils/theme";
import styled from 'styled-components';
import LoginBackground from "../../assets/login/login-background.png"

export const LoginPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  font-family: ${theme.fonts.primary};
  background-color: ${theme.colors.white};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60vh;
    background-image: 
      linear-gradient(
        to bottom, 
        rgba(71, 149, 119, 0.75), 
        rgba(71, 149, 119, 0.75)
      ),
      url(${LoginBackground}); 
    background-size: cover;
    background-position: center;
    z-index: 0;
  }
`;

export const CardWrapper = styled.div`
  background-color: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: ${theme.spacing(4)};
  width: 100%;
  max-width: 380px;
  text-align: center;
  z-index: 2;
  position: relative;
  margin-top: ${theme.spacing(26)};
`;

export const Header = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 8vh;
  color: ${theme.colors.white};
  z-index: 3;
  pointer-events: none;
`;

export const Logo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  & > span:first-child {
    font-size: 2.5em;
    font-weight: 300;
  }

  & > span:last-child {
    font-size: 1.2em;
    font-weight: 500;
    letter-spacing: 2px;
    margin-top: ${theme.spacing(-1)};
  }
`;

export const FooterLinkContainer = styled.div`
  margin-top: ${theme.spacing(3)};
  font-size: 0.9em;
`;

export const LinkText = styled.a`
  color: ${theme.colors.link};
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;